var _g, _g2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerkkoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 100,
    viewBox: "0 0 300 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#4F46E5",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7C3AED",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1F2937",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#4B5563",
      stopOpacity: 1
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#E5E7EB",
    strokeWidth: 2,
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 30,
    x2: 45,
    y2: 25
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 25,
    x2: 65,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 40,
    x2: 85,
    y2: 30
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 30,
    x2: 30,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 50,
    x2: 50,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 55,
    x2: 65,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: 30,
    x2: 95,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 50,
    x2: 75,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 55,
    x2: 75,
    y2: 65
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 30,
    r: 4,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 25,
    r: 6,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 40,
    r: 5,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 30,
    r: 4,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 50,
    r: 3,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 55,
    r: 4,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 50,
    r: 3,
    fill: "url(#nodeGradient)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 65,
    r: 4,
    fill: "url(#nodeGradient)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 50,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "url(#textGradient)"
  }, "VERKKO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkkoLogo);
export default __webpack_public_path__ + "static/media/verkko-logo.743612bcfe28f5a98fc7d4e28802be6d.svg";
export { ForwardRef as ReactComponent };